import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';
import { format } from 'date-fns';

const { FiHistory, FiClock, FiFileText, FiChevronRight, FiGitCommit } = FiIcons;

const ChangeLog = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      const { data } = await supabase.from('system_change_logs_1740000000003').select('*').order('request_timestamp', { ascending: false });
      if (data) setLogs(data);
    };
    fetchLogs();
  }, []);

  return (
    <div className="space-y-10">
      <div className="bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-2xl shadow-indigo-900/5">
        <h2 className="text-3xl font-black text-slate-900 tracking-tight flex items-center gap-4">
          <div className="w-12 h-12 bg-indigo-600 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-indigo-200">
            <SafeIcon icon={FiHistory} />
          </div>
          System Audit Trail
        </h2>
        <p className="text-slate-400 font-bold uppercase text-[10px] tracking-[0.2em] mt-2">Historical modification registry</p>
      </div>

      <div className="relative">
        <div className="absolute left-8 top-0 bottom-0 w-px bg-slate-200"></div>
        <div className="space-y-12">
          {logs.map((log, idx) => (
            <motion.div key={log.id} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: idx * 0.1 }} className="relative pl-24">
              <div className="absolute left-6 top-2 w-4 h-4 rounded-full bg-indigo-600 border-4 border-white shadow-lg z-10"></div>
              
              <div className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-xl transition-all group">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8">
                  <div>
                    <div className="flex items-center gap-3 text-indigo-600 font-black text-[10px] uppercase tracking-widest mb-2">
                      <SafeIcon icon={FiClock} />
                      {format(new Date(log.request_timestamp), 'PPP p')}
                    </div>
                    <h3 className="text-2xl font-black text-slate-900 tracking-tight">{log.title}</h3>
                  </div>
                  <div className="bg-slate-50 px-6 py-2 rounded-xl text-[10px] font-black text-slate-400 uppercase tracking-widest border border-slate-100">
                    ID: {log.id.substring(0,8)}
                  </div>
                </div>

                <p className="text-slate-500 font-medium text-lg leading-relaxed mb-8 max-w-3xl">
                  {log.description}
                </p>

                <div className="space-y-3">
                  <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4">Key Modifications</div>
                  {log.actions.map((action, aIdx) => (
                    <div key={aIdx} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100 group-hover:bg-indigo-50/50 transition-colors">
                      <div className="flex items-center gap-4">
                        <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center text-indigo-600 shadow-sm">
                          <SafeIcon icon={FiFileText} />
                        </div>
                        <div>
                          <div className="text-sm font-black text-slate-900">{action.file}</div>
                          <div className="text-[10px] font-bold text-slate-400">{action.reason}</div>
                        </div>
                      </div>
                      <div className="flex items-center gap-6">
                        <div className="text-[10px] font-mono font-black text-indigo-600 bg-white px-3 py-1 rounded-lg border border-indigo-100">
                          Lines {action.lines}
                        </div>
                        <SafeIcon icon={FiChevronRight} className="text-slate-300" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChangeLog;